module.exports = "../img/Sprite-Horoscopo.png";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Sprite-Horoscopo.png
// module id = 37
// module chunks = 0